import React, { useContext } from 'react';
import { Grid } from '@elliemae/ds-grid';
import { ControlledDateTimePickerContext } from '../../ControlledDateTimePickerCTX.js';
import { MMInput } from './MMInput.js';
import { DDInput } from './DDInput.js';
import { YYYYInput } from './YYYYInput.js';
import { StyledFocusWithIn, StyledSeparator } from '../Styleds.js';
import { useDateInputs } from './useDateInputs.js';
import { fixedValues } from '../config.js';

export const DateInputs = (): JSX.Element => {
  const {
    month,
    day,
    year,
    autoFocusMonthInput,
    innerRefMonthInput,
    onMonthChange,
    onDayChange,
    onYearChange,
    onMonthBlur,
    onDayBlur,
    onYearBlur,
    onMonthFocus,
    onDayFocus,
    onYearFocus,
    onMonthKeyDown,
    onDayKeyDown,
    onYearKeyDown,
    disabled,
    applyAriaDisabled,
  } = useDateInputs();
  // we do this here so MMInput,DDInput,YYYYInput can be pure component memoized via React.memo
  const {
    monthInputRef,
    dayInputRef,
    yearInputRef,
    latestInteractionRegion,
    currFocusDescriber,
    getProps,
    props: { tabIndex, hasError, readOnly },
  } = useContext(ControlledDateTimePickerContext);

  return (
    <Grid
      cols={[
        fixedValues.smallInputWidth,
        fixedValues.separatorWidth,
        fixedValues.smallInputWidth,
        fixedValues.separatorWidth,
        fixedValues.largeInputWidth,
      ]}
    >
      <StyledFocusWithIn>
        <MMInput
          onChange={onMonthChange}
          onBlur={onMonthBlur}
          onFocus={onMonthFocus}
          onKeyDown={onMonthKeyDown}
          value={month}
          contextRef={monthInputRef}
          innerRef={innerRefMonthInput}
          tabIndex={tabIndex}
          autoFocusMonthInput={autoFocusMonthInput}
          placeholder="MM"
          disabled={disabled}
          applyAriaDisabled={applyAriaDisabled}
          hasError={hasError}
          isFocused={latestInteractionRegion === 'date-inputs' && currFocusDescriber === 'month-input'}
          getProps={getProps}
          readOnly={readOnly}
        />
      </StyledFocusWithIn>
      <StyledSeparator alignItems="center">/</StyledSeparator>
      <StyledFocusWithIn>
        <DDInput
          onChange={onDayChange}
          onBlur={onDayBlur}
          onFocus={onDayFocus}
          onKeyDown={onDayKeyDown}
          value={day}
          contextRef={dayInputRef}
          tabIndex={tabIndex}
          placeholder="DD"
          disabled={disabled}
          applyAriaDisabled={applyAriaDisabled}
          hasError={hasError}
          isFocused={latestInteractionRegion === 'date-inputs' && currFocusDescriber === 'day-input'}
          getProps={getProps}
          readOnly={readOnly}
        />
      </StyledFocusWithIn>
      <StyledSeparator alignItems="center">/</StyledSeparator>
      <StyledFocusWithIn>
        <YYYYInput
          onChange={onYearChange}
          onBlur={onYearBlur}
          onFocus={onYearFocus}
          onKeyDown={onYearKeyDown}
          value={year}
          contextRef={yearInputRef}
          tabIndex={tabIndex}
          placeholder="YYYY"
          disabled={disabled}
          applyAriaDisabled={applyAriaDisabled}
          hasError={hasError}
          isFocused={latestInteractionRegion === 'date-inputs' && currFocusDescriber === 'year-input'}
          getProps={getProps}
          readOnly={readOnly}
        />
      </StyledFocusWithIn>
    </Grid>
  );
};
